(function($){
	$(function(){
		var OneTrustCode = document.location.href.toString().indexOf( 'asndev.com.br' ) > 0 ? '6c750db7-64fa-49db-97a5-9d332de19973' : '6e1d29eb-e0fb-429b-8196-d613de7e621a';
		$( 'head' )
			.append('<script type="text/javascript" src="https://cdn.cookielaw.org/' + OneTrustCode + '/OtAutoBlock.js" async />' )
			.append('<script type="text/javascript" src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" charset="UTF-8" data-domain-script="' + OneTrustCode + '" async />')
		;
	});	
})(jQuery);